export default "__VITE_ASSET__GarzcI7K__"